import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as actions from './../../../actions';
import FieldWrapper from './FieldWrapper';
import DropDownModal from '../../Editors/DropDownModal';
import Label from '../../../../components/svg/Label';
import TextAreaField from '../../../../components/TextAreaField';
import { Rgba, getHexColorString, getOpacityFromRgba } from '../../../../helpers/helpers';
import { RootState, Sortable } from 'gf-types';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

export type DropDownItem = { text: string; value: string; displayName: string } & Sortable;

export interface DropDownFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  foregroundColor: Rgba;
  backgroundColor: Rgba;
  fontName?: string;
  fontSize?: number;
  padding?: number;
  editable: boolean;
  value?: string;
  dropdownItems?: DropDownItem[];
  itemCollectionTemplateId?: string;
  itemCollections?: TypeMePlease[];
  allowOther: boolean;
  wrapText: boolean;
}

//@ts-ignore - FIX
@connect(
  (state: RootState) => ({
    itemCollections: state.formeditor.itemCollections
  }),
  actions
)
export default class DropDownField extends PureComponent<DropDownFieldProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleDropdownChanged = this.handleDropdownChanged.bind(this);

    this.state = { dropdownOpen: false };
  }

  mouseDown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  handleModalClose() {
    this.setState({ dropdownOpen: false });
  }

  handleDropdownChanged(data) {
    this.props.valueUpdated({ value: data });
    this.setState({ dropdownOpen: false });
  }

  render() {
    let dropdownModal = null;
    let options = null;

    if (this.props.dropdownItems) {
      options = [...this.props.dropdownItems].sort((a, b) => a.sortNumber - b.sortNumber).map((item) => ({ value: item.value, text: item.displayName }));
    } else if (this.props.itemCollections && this.props.itemCollectionTemplateId) {
      const itemCollection = this.props.itemCollections.find((p) => p.id === this.props.itemCollectionTemplateId);
      if (itemCollection) {
        options = [...itemCollection.items].sort((a, b) => a.sortNumber - b.sortNumber).map((item) => ({ value: item.value, text: item.displayName }));
      }
    }

    let text = this.props.value;
    const matchingOption = options ? options.find((x) => x.value === this.props.value) : null;
    if (matchingOption) {
      text = matchingOption.text;
    }

    dropdownModal = (
      <DropDownModal
        open={this.state.dropdownOpen}
        onClose={this.handleModalClose}
        allowOther={this.props.allowOther}
        dropdownItems={options}
        value={this.props.value}
        valueUpdated={this.props.valueUpdated}
        onChanged={this.handleDropdownChanged}
      />
    );
    let innerElement: JSX.Element;
    if (this.props.wrapText) {
      innerElement = (
        <TextAreaField
          text={text}
          fontName={this.props.fontName}
          fontSize={this.props.fontSize}
          width={this.props.w}
          height={this.props.h}
          align={this.props.align}
          padding={this.props.padding}
          foregroundColor={getHexColorString(this.props.foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(this.props.foregroundColor)}
        />
      );
    } else {
      innerElement = (
        <Label
          text={text}
          fontName={this.props.fontName}
          fontSize={this.props.fontSize}
          width={this.props.w}
          align={this.props.align}
          padding={this.props.padding}
          foregroundColor={getHexColorString(this.props.foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(this.props.foregroundColor)}
        />
      );
    }
    return (
      <FieldWrapper
        onMouseDown={this.mouseDown}
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor}
        editable={this.props.editable}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        {innerElement}
        {dropdownModal}
      </FieldWrapper>
    );
  }
}
